import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, makeStyles } from '@material-ui/core';
import { updateInterviewStatus } from '../../../../actions/interview.action';
import { useDispatch, useSelector, connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
   dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: 'inherit',
      width: '300px',
      margin: '0',
   },
   select: {
      marginBottom: theme.spacing(2),
      width: '100%',
   },
   button: {
      color: '#5f4b95',
      border: '1px solid #5f4b95',
      backgroundColor: '#f8f5ff',
      fontSize: '12px',
      fontWeight: '600',
      padding: '5px 15px',
      '&:hover': {
         backgroundColor: '#5f4b95',
         color: '#fff',
      },
   },
}));

const StatusModal = ({ updateInterviewStatus, data }) => {
   const dispatch = useDispatch();
   const classes = useStyles();
   let { interview_status_toggle } = useSelector((state) => state.interviewReducer);
   const [status, setStatus] = useState(3);

//    useEffect(() => {
//       if ((data && data.interviewStatus) !== undefined) {
//          setStatus(() => data.interviewStatus);
//       }
//    }, [data]);

   const handleChange = (event) => {
      setStatus(event.target.value);
   };

   const handleUpdate = () => {
      let obj = {
         Id: data._id,
         interviewStatus: status,
      };
      
      updateInterviewStatus(obj);
   };

   const handleOnClose = () => {
      dispatch({ type: 'INTERVIEW_STATUS_TOGGLE', payload: !interview_status_toggle });
   };

   return (
      <Dialog open={interview_status_toggle} onClose={handleOnClose} aria-labelledby="form-dialog-title">
         <DialogTitle id="form-dialog-title">Update Status</DialogTitle>
         <DialogContent className={classes.dialogContent}>
            <Select value={status} onChange={handleChange} className={classes.select} displayEmpty>
               <MenuItem value={3}>Confirmed</MenuItem>
               <MenuItem value={0}>Cancelled</MenuItem>
            </Select>
         </DialogContent>
         <DialogActions>
            <Button onClick={handleOnClose} color="primary">
               Cancel
            </Button>
            <Button onClick={handleUpdate} className={classes.button}>
               Update
            </Button>
         </DialogActions>
      </Dialog>
   );
};

const mapStateToProps = ({ StatusModalComponent }) => {
   return { StatusModalComponent };
};

export default connect(mapStateToProps, {
   updateInterviewStatus,
})(StatusModal);
